"use strict";

require("../../../util/GlobalScript.js");

var HeaderBar = require("./HeaderBar");

HeaderBar.Reducer = require("./Reducer");
HeaderBar.Actions = require("./Actions");
module.exports = HeaderBar;